import { Component, EventEmitter, Input, Output, OnInit, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { FilteredSaleOrder } from '../../services/load-management.service';
import { FilteredSaleOrderWithInvoice } from '../../services/sales-flow-service';

@Component({
  selector: 'app-packup-orders-list',
  standalone: true,
  imports: [CommonModule, FormsModule, MatCardModule, MatChipsModule, MatInputModule, MatFormFieldModule, MatIconModule],
  templateUrl: './packup-orders-list-component.html',
  styleUrls: ['./packup-orders-list-component.scss']
})
export class PackupOrdersListComponent implements OnInit, OnChanges {
  @Input() orders: FilteredSaleOrderWithInvoice[] = [];
  @Output() select = new EventEmitter<FilteredSaleOrderWithInvoice>();

  searchTerm: string = '';
  filteredOrders: FilteredSaleOrderWithInvoice[] = [];

  ngOnInit(): void {
    this.filteredOrders = [...this.orders];
  }

  ngOnChanges(): void {
    this.filteredOrders = [...this.orders];
    this.applyFilter();
  }

  onSearchChange(): void {
    this.applyFilter();
  }

  private applyFilter(): void {
    if (!this.searchTerm.trim()) {
      this.filteredOrders = [...this.orders];
      return;
    }

    const searchLower = this.searchTerm.toLowerCase().trim();
    this.filteredOrders = this.orders.filter(order => 
      order.name.toLowerCase().includes(searchLower) ||
      (order.customerName && order.customerName.toLowerCase().includes(searchLower))
    );
  }

  onRowClick(order: FilteredSaleOrderWithInvoice): void {
    this.select.emit(order);
  }
}


